/** The onboarding queue survives OAuth round trips in sessionStorage. */
import { session } from '@/lib/storage';

const KEY = 'mydash.onboarding';

export interface OnboardingState {
  queue: string[];
  done: string[];
  skipped: string[];
}

export function readOnboarding(): OnboardingState | null {
  return session.get<OnboardingState | null>(KEY, null);
}

export function writeOnboarding(s: OnboardingState | null): void {
  if (s) session.set(KEY, s);
  else session.remove(KEY);
}

export function markOnboardingDone(integrationId: string): void {
  const s = readOnboarding();
  if (!s || !s.queue.includes(integrationId)) return;
  if (!s.done.includes(integrationId)) s.done.push(integrationId);
  writeOnboarding(s);
}

export function currentOnboardingStep(s: OnboardingState | null): string | null {
  if (!s) return null;
  return s.queue.find((id) => !s.done.includes(id) && !s.skipped.includes(id)) ?? null;
}
